<!-- 绑定手机号 -->
<template>
  <div class="bindPhoneNum loginCom">
    <returnPage/>
    <div class="bindPhoneNumMain loginMmain">
      <div class="bindPhoneNumMain_title">绑定手机号码</div>
      <div class="bindPhoneNumMain_describe">绑定手机号，让你的账号更加安全</div>
      <div class="bindPhoneNumIpt">
        <input type="number" maxlength="11" placeholder="请输入手机号码">
      </div>
      <div class="bindPhoneNumLine loginLine"></div>
    </div>
    <sendButton buttonText="发送验证码"/>
  </div>
</template>

<script>
import '@/assets/css/loginCommon.css';
import returnPage from '@/components/login/returnPage.vue';
import sendButton from '@/components/login/sendButton.vue';

export default {
  components: { returnPage, sendButton },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {
    document.getElementsByClassName('app')[0].setAttribute('style', 'background-color:#fff');
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
    document.getElementsByClassName('app')[0].removeAttribute('style');
  },
  destroyed() {},
  activated() {},
};
</script>
<style lang='scss' scoped>
.bindPhoneNum {
  .bindPhoneNumMain {
    .bindPhoneNumMain_title {
      font-size: 51px;
      font-weight: 500;
      color: #333333;
      padding-top: 89px;
      line-height: 72px;
    }

    .bindPhoneNumMain_describe {
      font-size: 29px;
      font-weight: 400;
      color: #787878;
      margin: 20px 0 94px 0;
      line-height: 40px;
    }

    .bindPhoneNumIpt {
      margin-bottom: 22px;
    }

    .bindPhoneNumLine {
      margin-bottom: 56px;
    }
  }
}
</style>
